var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.38 5.56c.82-.82.82-2.14 0-2.96-.8-.8-2.14-.8-2.94.02L10 7.04 5.56 2.62c-.8-.82-2.14-.82-2.94 0-.8.82-.82 2.14 0 2.96L7.04 10l-4.42 4.44c-.82.8-.82 2.14 0 2.94.82.82 2.14.82 2.96 0L10 12.96l4.44 4.44c.82.82 2.14.82 2.96 0 .82-.82.82-2.14 0-2.96L12.96 10l4.42-4.44z","fill":"#C3DBF7"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
